<template>
  <div class="mainCommonListContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button
          @click="showDialog()"
          v-if="null !== addPermission"
          class="addBtn"
          >{{ addPermission.name }}</el-button>
      </div>
      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索部门名称"
              @keyup.enter.native="handleCurrentChange(1)"
            >
              <i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
              >
              </i
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="name"
          label="部门名称"
          min-width="70"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="updatedAt"
          :formatter="dateFormat"
          label="更新时间"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>

        <el-table-column
          label="操作"
          min-width="100"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'department-edit'"
                  @click="edit(scope.row.id)"
                  icon="el-icon-operte-view"
                  class="editBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                >
                <el-button
                  v-else-if="button.path === 'department-del'"
                  @click="del(scope.row.id)"
                  icon="el-icon-operte-view"
                  class="delBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
          height: 40px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 12, 18, 24]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          popper-class="adminHomeSelect"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="部门名称"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="637px"
      class="commonSimpleDialog"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="0px"
        @submit.native.prevent
      >
        <el-form-item label="" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请填写部门名称(20字内)"
            maxlength="20"
            clearable
            @keyup.enter.native="submit('form')"
          ></el-input>
          <el-button
            type="primary"
            @click="submit('form')"
            class="confirmBtn"
            :loading="loading"
            >确 定</el-button
          ><el-button @click="dialogVisible = false" class="cancelBtn"
            >取 消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "department",
  props: ["menuId"],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      addPermission: null,
      buttonList: [],
      form: { name: "" },
      rules: {
        name: [{ required: true, message: "请填写部门名称~", trigger: "blur" }],
      },
      queryForm: {
        name: "",
        removed: 0,
      },
      current: 1, //当前页数
      size: 6, //显示几条
      total: 0, //总条数
      tableData: [],
    };
  },
  methods: {
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    //跳出弹框
    showDialog() {
      this.dialogVisible = true;
      this.form = {};
    },
    // 提交表单
    submit(formName) {
      try {
        this.loading = true;
        // 进行验证表单内容是否填写正确
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.form.id) {
              //编辑
              this.update(this.form);
            } else {
              //新增
              this.save(this.form);
            }
          } else {
            return false;
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    // 新增
    save(form) {
      this.postJsonRequest("/user-server/api/u-department/save", form).then(
        (res) => {
          let oData = res.data;
          let _this = this;
          if (oData.code === 0) {
            _this.dialogVisible = false; //关闭弹框
            _this.query();
            this.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        }
      );
    },
    // 查询
    query(queryType) {
      try {
        this.loading = true;
        let params = {};
        let current = 1;
        let size = 6;
        if (queryType === "queryById") {
          params = {
            ...this.form,
          };
        } else {
          params = { ...this.queryForm };
          current = this.current;
          size = this.size;
        }
        this.postJsonRequest(
          "/user-server/api/u-department/query?current=" +
            current +
            "&size=" +
            size,
          params
        ).then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (queryType === "queryById") {
              this.form = data.records[0];
            } else {
              this.tableData = data.records;
              this.total = data.total;
            }
          } else if (oData.code != 401) {
            // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    dateFormat(row, column) {
      let date = row[column.property];
      if (date) {
        return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
      }
      return "";
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    //编辑
    edit(id) {
      this.dialogVisible = true;
      this.form = {};
      this.form.id = id;
      this.query("queryById");
    },
    // 编辑
    update(form) {
      this.putJsonRequest("/user-server/api/u-department/update", form).then(
        (res) => {
          let oData = res.data;
          let _this = this;
          if (oData.code === 0) {
            _this.dialogVisible = false; //关闭弹框
            _this.query();
            this.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        }
      );
    },
    //删除
    del(id) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.deleteRequest(
            "/user-server/api/u-department/delete?id=" + id
          ).then((res) => {
            let oData = res.data;
            if (oData.code == 0) {
              let totalPage = Math.ceil((this.total - 1) / this.size);
              let currentPage =
                this.current > totalPage ? totalPage : this.current;
              this.current = currentPage < 1 ? 1 : currentPage;
              this.query();
              this.$message({
                message: "删除成功",
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {},
              });
            } else if (oData.code != 401) {
              let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "customClass-style",
                iconClass: "",
                dangerouslyUseHTMLString: true,
                confirmButtonClass: "confirm-style",
                showCancelButton: false,
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];

          if (child) {
            if (child.path === "department-add") {
              this.addPermission = child;
            } else if (child.path !== "department-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
  },
  watch: {
    dialogVisible: function (nval, oval) {
      this.defaultClearValidate("form");
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/user/department.vue